'use strict';

var AbstractWizardView = require('components/common/views/abstract_wizard_view');
var OOP = require('utils/oop');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var Validation = require('utils/validation');
var Notification = require('utils/notification');
var App = require('app');
var AppState = require('app_state');

module.exports = OOP.extend(
    AbstractWizardView,
    {
        template: require('components/profile/templates/webhook_dialog'),

        ui: {
            inputName: '#name-input',
            inputUrl: '#url-input',
            inputKey: '#key-input',
            inputVal: '#val-input',
            active: '#active',
        },

        events: OOP.inheritedObj('events', {
            'keyup .form-control': function () {
                var self = this;
                _.each(['name', 'url', 'key', 'val'], function (data) {
                    self.formData[data] = $('#' + data + '-input').val();
                });
            },

            'click #active': function () {
                this.formData.active = $('#active').prop('checked');
            },

            'click #trywebhookurl': function () {
                var self = this;
                $.when(
                    App.request(
                        'webhook:url:test',
                        this.formData.url || '',
                        this.formData.key || '',
                        this.formData.val || ''
                    )
                ).done(function (data) {
                    self.formData.try = data;
                    self.render();

                    var message =
                        data.code && data.time
                            ? I18N.TR('Webhook Antwort') +
                              ': ' +
                              I18N.TR('Code') +
                              ' ' +
                              data.code +
                              ' -- ' +
                              I18N.TR('Zeit') +
                              ' ' +
                              Math.round(data.time / 1000000) +
                              ' ms'
                            : I18N.TR('Webhook konnte nicht gesendet werden. Bitte prüfen Sie die URL.');

                    Notification.show(data.code == 200 ? 'success' : 'error', I18N.TR('Webhook URL Test'), message);
                });
            },

            'change #group_multi_select': function () {
                this.formData.webhook_events = $('#group_multi_select').val();
            },
        }),

        initialize: function (options) {
            this.base.initialize(options);

            this.formData = {
                name: this.options.webhookModel.get('name'),
                url: this.options.webhookModel.get('url'),
                key: this.options.webhookModel.get('header_key'),
                val: this.options.webhookModel.get('header_value'),
                active: this.options.webhookModel.get('active'),
                webhook_events: _.map(this.options.webhookModel.get('webhook_events'), function (e) {
                    return e.reference_id + '_' + e.event_type;
                }),
            };
        },

        serializeData: function () {
            var data = this.base.serializeData();
            data.alarmList = this.options.alarmList.toJSON();

            data.isUpdated = this.options.webhookModel.id > 0;

            data.wizardContext = this.getWizardContext();

            data.formData = this.formData;
            data.errors = this.errors;

            data.urlTestSucceeded = this.formData.try ? this.formData.try.code == 200 : false;
            data.urlTestFailed = this.formData.try ? this.formData.try.code != 200 : false;

            data.can_see_type1 = AppState.user.get('features').webhook_event_type.includes(1);
            data.can_see_type2 = AppState.user.get('features').webhook_event_type.includes(2);
            data.can_see_type3 = AppState.user.get('features').webhook_event_type.includes(3);
            data.can_see_type4 = AppState.user.get('features').webhook_event_type.includes(4);

            data.noEventsSelectable = data.alarmList.length == 0;

            return data;
        },

        onShow: function () {
            this.base.onShow();
            this.initControls();
        },

        onRender: function () {
            this.initControls();
        },

        canWizardFinish: function () {
            return this.base.canWizardFinish() && this.selected == 2;
        },

        wizardDone: function () {
            var isValid = this.wizardValidate(function (frm) {
                this.required('name', frm.formData.name, I18N.TR('Ein Name muss angegeben werden.'), frm.ui.inputName, {
                    page: 2,
                });
                this.required('url', frm.formData.url, I18N.TR('Eine URL muss angegeben werden.'), frm.ui.inputUrl, {
                    page: 2,
                });
                this.custom(
                    'url',
                    function () {
                        if (frm.formData.url.startsWith('https')) {
                            return '';
                        } else {
                            return I18N.TR('Webhooks können ausschließlich über HTTPS empfangen werden.');
                        }
                    },
                    frm.ui.inputUrl,
                    { page: 2 }
                );
            });
            if (!isValid) {
                return;
            }

            this.setError(undefined);

            var self = this;
            this.options.webhookModel.save(
                {
                    name: this.formData.name,
                    url: this.formData.url,
                    header_key: this.formData.key,
                    header_value: this.formData.val,
                    active: this.formData.active,
                    webhook_events: _.map(this.formData.webhook_events, function (e) {
                        var event = e.split('_');
                        return { reference_id: parseInt(event[0]), event_type: parseInt(event[1]) };
                    }),
                },
                {
                    success: function () {
                        App.hideModal();
                        self.options.callBackFunc();
                    },
                    error: function (m, r) {
                        self.errors = r.responseJSON;
                        self.render();
                    },
                }
            );
        },

        initControls: function () {
            Misc.initializeMultiSelect('#group_multi_select', I18N.TR('Verfügbar'), I18N.TR('Ausgewählt'));
        },

        setError: function (errorData) {
            this.base.setError(errorData);
            this.changePage(this.selected, true);
        },
    },
    'WebhookDialogView'
);
